import {Box, Stack, Tooltip, Typography} from "@mui/material";
import {c, mono} from "../landingTokens";
import {Section} from "./Shell";
import axiansLogo from "../../../assets/images/axians.webp";
import finkiLogo from "../../../assets/images/finki.png";
import fitrLogo from "../../../assets/images/fitr.png";
import zanMitrevLogo from "../../../assets/images/zan-mitrev.png";

const PARTNERS = [
  {name: "FINKI", image: finkiLogo},
  {name: "Axians", image: axiansLogo},
  {name: "FITR", image: fitrLogo},
  {name: "Zan Mitrev Clinic", image: zanMitrevLogo},
];

export const Partners = () => (
  <Section label="Partners" sx={{textAlign: "center"}}>
    <Typography sx={{fontFamily: mono, fontSize: "11.5px", letterSpacing: "0.16em", textTransform: "uppercase", color: c.inkMuted, mb: 4.25}}>
      Built and backed with
    </Typography>

    <Stack direction="row" flexWrap="wrap" useFlexGap justifyContent="center" gap={2}>
      {PARTNERS.map((partner) => (
        <Tooltip key={partner.name} title={partner.name} arrow>
          <Box
            sx={{
              flex: "1 1 180px",
              maxWidth: 240,
              aspectRatio: "16 / 7",
              border: `1px solid ${c.line}`,
              borderRadius: "18px",
              display: "grid",
              placeItems: "center",
              bgcolor: c.bgSoft,
              p: 2.5,
            }}
          >
            <Box
              component="img"
              src={partner.image}
              alt={partner.name}
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                filter: "grayscale(1)",
                opacity: 0.75,
                transition: "filter .2s ease, opacity .2s ease",
                "&:hover": {filter: "grayscale(0)", opacity: 1},
              }}
            />
          </Box>
        </Tooltip>
      ))}
    </Stack>
  </Section>
);
